import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WHATSAPP_URL, SOCIAL_LINKS } from '../constants/contact';
import { LOGO } from '../constants/images';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaWhatsapp,
} from 'react-icons/fa';

function Footer() {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src={LOGO} alt="Mitzva Tank" className="footer-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} loading="lazy" decoding="async" />
            <p>Un proyecto de Judaísmo sin fronteras</p>
          </div>
          <div className="footer-section">
            <h4>Enlaces Rápidos</h4>
            <button onClick={() => scrollToSection('inicio')}>Inicio</button>
            <button onClick={() => scrollToSection('donar')}>Donar</button>
            <button onClick={() => scrollToSection('mision')}>¿Quiénes somos?</button>
            <button onClick={() => handleNavigate('/actividades')}>Actividades y novedades</button>
            <button onClick={() => handleNavigate('/ruta')}>La ruta</button>
            <button onClick={() => handleNavigate('/localidades')}>Localidades Visitadas</button>
            <button onClick={() => handleNavigate('/festividades')}>Festividades</button>
            <button onClick={() => handleNavigate('/campanas')}>Las 10 Campañas</button>
            <button onClick={() => handleNavigate('/mitzva-tank-mundo')}>Mitzva Tank en el mundo</button>
            <button onClick={() => handleNavigate('/galeria')}>Galería de fotos</button>
          </div>
          <div className="footer-section">
            <h4>Las 10 Campañas</h4>
            <p>Tefilín • Tzedaká • Libros de Torá</p>
            <p>Mezuzá • Velas de Shabat • Comida Kasher</p>
            <p>Pureza Familiar • Educación Judía</p>
            <p>Estudio de Torá • Amor al Prójimo</p>
            <button onClick={() => handleNavigate('/campanas')} style={{ marginTop: '0.5rem' }}>
              Ver todas las campañas
            </button>
          </div>
          <div className="footer-section">
            <h4>Seguinos</h4>
            <div className="footer-social">
              <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" title="Facebook">
                <FaFacebook />
              </a>
              <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" title="Instagram">
                <FaInstagram />
              </a>
              <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" title="YouTube">
                <FaYoutube />
              </a>
              <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" title="TikTok">
                <FaTiktok />
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Mitzva Tank Argentina. Todos los derechos reservados.</p>
          <p className="footer-design">Design by E.O.M Software</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
